import {MockCountRange} from '../../config/types';

export const getInRange = (range?: MockCountRange): number => {
  if (range === undefined) return 1;

  const rng = typeof range === 'number' ? [0, range] : range;
  const span = Math.abs(rng[0] - rng[1]) + 1;
  return Math.abs(Math.round(Math.random() * span - 0.5)) + rng[0];
};
